import { render, staticRenderFns } from "./detailsStatus.vue?vue&type=template&id=d9ba8902&scoped=true"
import script from "./detailsStatus.vue?vue&type=script&lang=js"
export * from "./detailsStatus.vue?vue&type=script&lang=js"
import style0 from "./detailsStatus.vue?vue&type=style&index=0&id=d9ba8902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ba8902",
  null
  
)

export default component.exports